export const PASSWORD_MIN_LENGTH = 10;
export const PASSWORD_MAX_LENGTH = 256;

export function passwordProblem(current: string, next: string, confirm: string): string | null {
  if (current.length === 0) {
    return 'Enter your current password.';
  }
  if (next.length < PASSWORD_MIN_LENGTH) {
    return `The new password must be at least ${PASSWORD_MIN_LENGTH} characters.`;
  }
  if (next.length > PASSWORD_MAX_LENGTH) {
    return `The new password must be at most ${PASSWORD_MAX_LENGTH} characters.`;
  }
  if (next.trim().length === 0) {
    return 'The new password cannot consist of spaces only.';
  }
  if (next === current) {
    return 'The new password must differ from the current one.';
  }
  if (next !== confirm) {
    return 'The new passwords do not match.';
  }
  return null;
}
